import { render, staticRenderFns } from "./PropostaParcela.vue?vue&type=template&id=332cb343"
import script from "./PropostaParcela.vue?vue&type=script&lang=js"
export * from "./PropostaParcela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports